<template>
  <div class="d-company-ratings__app">
    <template v-if="ratingsData">
      <div class="d-company-ratings__sorter">
        <!-- <d-select :data-options="options" v-model="currentSorting" data-placeholder="Год"></d-select> -->
        <d-tabs-ratings :tabs="yearTabs" :active-tab="currentYear" @update:activeTab="currentYear = $event" />
      </div>
      <div class="d-company-ratings__list" data-ratings-opts="{&quot;perPageNum&quot;: 3}">

        <div v-for="rating in filteredratings" :key="rating.id" class="d-company-rating">
          <div class="d-company-rating__col _col1">
            <div class="d-company-rating__place">
              <img v-if="rating.img" :src="rating.img" />
              <span>{{ rating.place === 0 ? '' : `${rating.place} место` }}</span>
            </div>
            <div class="d-company-rating__info"> {{ rating.info }}</div>
          </div>
          <div class="d-company-rating__col _col2">{{ rating.nomination }}</div>
          <div class="d-company-rating__col _col3" v-html="rating.organizer"></div>
          <div class="d-company-rating__col _col4">{{ rating.date }}</div>
          <div class="d-company-rating__col _col5">
            <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5.83366 7.50016C4.45295 7.50016 3.33366 8.61945 3.33366 10.0002C3.33366 11.3809 4.45295 12.5002 5.83366 12.5002H8.33366C8.7939 12.5002 9.16699 12.8733 9.16699 13.3335C9.16699 13.7937 8.7939 14.1668 8.33366 14.1668H5.83366C3.53247 14.1668 1.66699 12.3013 1.66699 10.0002C1.66699 7.69898 3.53247 5.8335 5.83366 5.8335H8.33366C8.7939 5.8335 9.16699 6.20659 9.16699 6.66683C9.16699 7.12707 8.7939 7.50016 8.33366 7.50016H5.83366Z" />
              <path
                d="M5.83366 10.0002C5.83366 9.53993 6.20676 9.16683 6.66699 9.16683H13.3337C13.7939 9.16683 14.167 9.53993 14.167 10.0002C14.167 10.4604 13.7939 10.8335 13.3337 10.8335H6.66699C6.20676 10.8335 5.83366 10.4604 5.83366 10.0002Z" />
              <path
                d="M16.667 10.0002C16.667 8.61945 15.5477 7.50016 14.167 7.50016H11.667C11.2068 7.50016 10.8337 7.12707 10.8337 6.66683C10.8337 6.20659 11.2068 5.8335 11.667 5.8335H14.167C16.4682 5.8335 18.3337 7.69898 18.3337 10.0002C18.3337 12.3013 16.4682 14.1668 14.167 14.1668H11.667C11.2068 14.1668 10.8337 13.7937 10.8337 13.3335C10.8337 12.8733 11.2068 12.5002 11.667 12.5002H14.167C15.5477 12.5002 16.667 11.3809 16.667 10.0002Z" />
            </svg>
          </div>
          <a v-if="rating.link" :href="rating.link" target="_blank" class="d-company-rating__link"></a>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import DSelect from "@components/molecules/DSelect.vue";
import DTabsRatings from "../molecules/DTabsRatings.vue";
import { uniqBy as _uniqBy, sortBy as _sortBy } from "lodash";

export default {
  name: "DCompanyratings",
  components: {
    DSelect,
    DTabsRatings,
  },
  props: {
    apiUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      ratingsData: null,
      ratings: [
        {
          "id": 3212,
          "year": 2022,
          "img": "",
          "place": 8,
          "info": "",
          "nomination": "ТОП застройщиков РФ по текущему строительству",
          "organizer": "Единый реестр застройщиков (ЕРЗ)",
          "date": "31.12.2022",
          "link": "#"
        },
        {
          "id": 3213,
          "year": 2022,
          "img": "",
          "place": 19,
          "info": "",
          "nomination": "ТОП застройщиков РФ по объему ввода жилья",
          "organizer": "Единый реестр застройщиков (ЕРЗ)",
          "date": "31.12.2022",
          "link": "#"
        },
        {
          "id": 3214,
          "year": 2022,
          "img": "",
          "place": 114,
          "info": "",
          "nomination": "Рейтинг крупнейших по выручке компаний России — РБК 500",
          "organizer": "РБК",
          "date": "31.12.2022",
          "link": "#"
        },
        {
          "id": 3215,
          "year": 2022,
          "img": "/assets/img/d/icon_cup.svg",
          "place": 1,
          "info": "",
          "nomination": "20 крупнейших застройщиков ",
          "organizer": "Forbes",
          "date": "31.12.2022",
          "link": "#"
        },
        {
          "id": 3216,
          "year": 2022,
          "img": "/assets/img/d/icon_cup.svg",
          "place": 2,
          "info": "",
          "nomination": "Рейтинг уверенности российских застройщиков",
          "organizer": "Forbes",
          "date": "31.12.2022",
          "link": "#"
        },
        {
          "id": 3217,
          "year": 2022,
          "img": "/assets/img/d/icon_cup.svg",
          "place": 2,
          "info": "",
          "nomination": "10 самых успешных девелоперов «старой» Москвы ",
          "organizer": "Метриум",
          "date": "31.12.2022",
          "link": "#"
        },
        {
          "id": 3218,
          "year": 2022,
          "img": "/assets/img/d/icon_cup.svg",
          "place": 2,
          "info": "",
          "nomination": "10 самых успешных девелоперов «старой» Москвы ",
          "organizer": "Метриум",
          "date": "31.12.2022",
          "link": "#"
        },
        {
          "id": 3219,
          "year": 2022,
          "img": "/assets/img/d/icon_cup.svg",
          "place": 2,
          "info": "",
          "nomination": "10 самых успешных девелоперов «старой» Москвы ",
          "organizer": "Метриум",
          "date": "31.12.2022",
          "link": "#"
        },
        {
          "id": 3220,
          "year": 2022,
          "img": "/assets/img/d/icon_cup.svg",
          "place": 2,
          "info": "126 место в рейтинге RAEX-600",
          "nomination": "10 крупнейших компаний в строительстве из рейтинга RAEX-600",
          "organizer": "RAEX, ООО «РАЭКС Аналитика»",
          "date": "31.12.2022",
          "link": "#"
        },
        {
          "id": 3221,
          "year": 2022,
          "img": "",
          "place": 7,
          "info": "",
          "nomination": "Медиарейтинг  компаний–девелоперов ",
          "organizer": "СКАН-Интерфакс и онлайн-портал «Стройгазеты»",
          "date": "31.12.2022",
          "link": "#"
        },
        {
          "id": 3222,
          "year": 2022,
          "img": "",
          "place": 5,
          "info": "",
          "nomination": "Застройщики Москвы с наибольшей суммарной площадью сделок",
          "organizer": "Компания bnMap.pro (на сайте РБК)",
          "date": "31.12.2022",
          "link": "#"
        },
        {
          "id": 3223,
          "year": 2022,
          "img": "",
          "place": 8,
          "info": "",
          "nomination": "Топ-30 застройщиков Москвы",
          "organizer": "Циан",
          "date": "31.12.2022",
          "link": "#"
        },
        {
          "id": 3224,
          "year": 2022,
          "img": "",
          "place": 4,
          "info": "",
          "nomination": "Топ-5 застройщиков в России: лидеры по темпам строительства жилья",
          "organizer": "Яндекс.Недвижимость",
          "date": "31.12.2022",
          "link": "#"
        },
        {
          "id": 3225,
          "year": 2022,
          "img": "/assets/img/d/icon_cup.svg",
          "place": 3,
          "info": "",
          "nomination": "10 лучших застройщиков Москвы ",
          "organizer": "Комсомольская правда",
          "date": "31.12.2022",
          "link": "#"
        },
        {
          "id": 3226,
          "year": 2024,
          "img": "",
          "place": 10,
          "info": "",
          "nomination": "ТОП-10 застройщиков Москвы ",
          "organizer": "Портал novomoscow.ru",
          "date": "31.12.2024",
          "link": "#"
        },
        {
          "id": 3227,
          "year": 2024,
          "img": "/assets/img/d/icon_cup.svg",
          "place": 3,
          "info": "",
          "nomination": "20 крупнейших групп компаний по объему строящихся энергоэффективных проектов",
          "organizer": "Исследование Дом.рф",
          "date": "31.12.2024",
          "link": ""
        }
      ],
      currentSorting: null,
      options: null,
      currentYear: 'all',
    }
  },
  computed: {
    ratingsList() {
      if (this.ratingsData && this.ratingsData.ratings) return this.ratingsData.ratings;
      return null;
    },
    yearTabs() {
      const years = _uniqBy(this.ratingsList, 'year').map(rating => ({
        name: rating.year,
        value: rating.year
      }));
      return [
        { name: 'Все', value: 'all' },
        ..._sortBy(years, 'value').reverse()
      ];
    },

    filteredratings() {
      if (!this.ratingsList) {
        return null;
      }

      let filteredList = [...this.ratingsList];

      if (this.currentYear !== 'all') {
        filteredList = filteredList.filter(rating =>
          rating.year === parseInt(this.currentYear)
        );
        return filteredList.sort((a, b) => {
          if (a.place === 0 && b.place !== 0) return 1;
          if (b.place === 0 && a.place !== 0) return -1;
          if (a.place === 0 && b.place === 0) return 0;
          return a.place - b.place;
        });
      }

      return filteredList.sort((a, b) => {
        if (a.year !== b.year) return b.year - a.year;
        if (a.place === 0 && b.place !== 0) return 1;
        if (b.place === 0 && a.place !== 0) return -1;
        if (a.place === 0 && b.place === 0) return 0;
        return a.place - b.place;
      });
    },
  },
  created() {
    if (this.apiUrl) {
      this.getData()
    }
  },
  methods: {
    async getData() {
    try {
      let response = await this.axios.get(this.apiUrl);
      console.log('response company ratings', response.data);
      this.ratingsData = response.data;
      if (this.ratingsData && this.ratingsData.ratings && this.ratingsData.ratings.length > 0) {
        this.currentYear = Math.max(...this.ratingsData.ratings.map(rating => rating.year));
      }
    } catch (err) {
      console.log('error load company ratings data', err);
    }
  },
    moreratings() {
      this.ratingsTo += this.ratingsPerPage
    },
  }
}
</script>

<style scoped></style>